const defaults = {
  timeout: 2000,
  color: 'success',
  message: 'Something went wrong',
  bugReport: false
};

export default {
  namespaced: true,
  state: {
    items: [],
    cards: []
  },
  mutations: {
    item(state, props) {
      state.items.push({
        ...props,
        id: Math.floor(Math.random() * 1000000000)
      });
    },
    remove(state, item) {
      state.items = state.items.filter((i) => i.id !== item.id);
    },
    card(state, card) {
      state.cards.push(card);
    },
    popCard(state) {
      if (state.cards.length > 0) {
        state.cards.splice(0, 1);
      }
    }
  },
  actions: {
    show(context, props) {
      if (props == null) {
        props = {};
      }
      if (typeof props === 'string') {
        props = { message: props };
      }
      context.commit('item', Object.assign({}, defaults, props));
    },
    remove(context, item) {
      context.commit('remove', item);
    },
    showCard(context, card) {
      context.commit('card', card);
    },
    popCard(context) {
      context.commit('popCard');
    }
  }
};
